import { render } from "./CArticle.vue?vue&type=template&id=09b3a5b1"
import script from "./CArticle.vue?vue&type=script&lang=js"
export * from "./CArticle.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tung/Documents/GitHub/cc-faq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__